import React from 'react'

// styles
import styles from './index.module.scss'

const EcosystemSkeletonCard = () => {
  return (
    <div className={styles.container}>
      <div className={styles.topSection}>
        <div className="min-w-[76px] min-h-[76px] sm:min-w-[90px] sm:min-h-[90px]">
          <div className="skeletonLoader"></div>
        </div>
        <div className="w-full flex flex-col gap-[5px] sm:gap-[12px] ">
          <div className={styles.artistName}>
            <div className="skeletonLoader"></div>
          </div>
        </div>
      </div>
      <div className="w-full p-[20px] sm:p-[25px]">
        <div className={styles.border} />
        <div className="w-full flex justify-between items-center my-[15px] gap-[15px]">
          <div className="flex flex-wrap gap-[15px]">
            <div className="w-[100px] h-[24px] rounded-[12px] overflow-hidden">
              <div className="skeletonLoader"></div>
            </div>
            <div className="w-[100px] h-[24px] rounded-[12px] overflow-hidden">
              <div className="skeletonLoader"></div>
            </div>
          </div>
          <div className="gap-[10px] 2xl:gap-[15px] sm:flex hidden">
            <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
              <div className="skeletonLoader"></div>
            </div>
            <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
              <div className="skeletonLoader"></div>
            </div>
            <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
              <div className="skeletonLoader"></div>
            </div>
            <div className="w-[32px] h-[32px] rounded-[16px] overflow-hidden">
              <div className="skeletonLoader"></div>
            </div>
          </div>
        </div>
        <div className={styles.border} />
        <div className="w-full flex gap-[15px] mt-[15px]">
          <div className="w-full h-[45px] rounded-[23px] overflow-hidden">
            <div className="skeletonLoader"></div>
          </div>
          <div className="w-full h-[45px] rounded-[23px] overflow-hidden">
            <div className="skeletonLoader"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EcosystemSkeletonCard
